// Theme configuration for the system
// Multiple color themes available for customization

export const themes = {
  douradoo: {
    name: 'douradoo',
    description: 'Tema douradoo clássico',
    colors: {
      primary: '#DAA520',
      secondary: '#1D2C40',
      background: {
        default: '#000000',
        paper: '#1D2C40',
      },
      text: {
        primary: '#ffffff',
        secondary: '#DAA520',
      },
      border: {
        primary: 'rgba(218, 165, 32, 0.2)',
        hover: 'rgba(218, 165, 32, 0.5)',
        focus: '#DAA520',
      },
      hover: {
        light: 'rgba(218, 165, 32, 0.1)',
        medium: 'rgba(218, 165, 32, 0.2)',
      },
      progress: {
        background: 'rgba(255, 255, 255, 0.1)',
        fill: '#DAA520',
      },
      gradient: {
        top: '#DAA520',
        bottom: '#1D2C40',
      },
    },
  },
  azul: {
    name: 'Azul',
    description: 'Tema azul moderno',
    colors: {
      primary: '#2196F3',
      secondary: '#1565C0',
      background: {
        default: '#0A1929',
        paper: '#132F4C',
      },
      text: {
        primary: '#ffffff',
        secondary: '#64B5F6',
      },
      border: {
        primary: 'rgba(33, 150, 243, 0.2)',
        hover: 'rgba(33, 150, 243, 0.5)',
        focus: '#2196F3',
      },
      hover: {
        light: 'rgba(33, 150, 243, 0.1)',
        medium: 'rgba(33, 150, 243, 0.2)',
      },
      progress: {
        background: 'rgba(255, 255, 255, 0.1)',
        fill: '#2196F3',
      },
      gradient: {
        top: '#2196F3',
        bottom: '#1565C0',
      },
    },
  },
  verde: {
    name: 'Preto e Laranja',
    description: 'Tema preto com laranja vibrante',
    colors: {
      primary: '#FF9800',
      secondary: '#000000',
      background: {
        default: '#000000',
        paper: '#1A0F0A',
      },
      text: {
        primary: '#ffffff',
        secondary: '#FFB74D',
      },
      border: {
        primary: 'rgba(255, 152, 0, 0.2)',
        hover: 'rgba(255, 152, 0, 0.5)',
        focus: '#FF9800',
      },
      hover: {
        light: 'rgba(255, 152, 0, 0.1)',
        medium: 'rgba(255, 152, 0, 0.2)',
      },
      progress: {
        background: 'rgba(255, 255, 255, 0.1)',
        fill: '#FF9800',
      },
      gradient: {
        top: '#FF9800',
        bottom: '#000000',
      },
    },
  },
  roxo: {
    name: 'Minimalista',
    description: 'Tema minimalista preto e branco',
    colors: {
      primary: '#FFFFFF',
      secondary: '#1A1A1A',
      background: {
        default: '#000000',
        paper: '#1A1A1A',
      },
      text: {
        primary: '#FFFFFF',
        secondary: '#B0B0B0',
      },
      border: {
        primary: 'rgba(255, 255, 255, 0.2)',
        hover: 'rgba(255, 255, 255, 0.4)',
        focus: '#FFFFFF',
      },
      hover: {
        light: 'rgba(255, 255, 255, 0.1)',
        medium: 'rgba(255, 255, 255, 0.15)',
      },
      progress: {
        background: 'rgba(255, 255, 255, 0.1)',
        fill: '#FFFFFF',
      },
      gradient: {
        top: '#FFFFFF',
        bottom: '#1A1A1A',
      },
    },
  },
  vermelho: {
    name: 'Vermelho',
    description: 'Tema vermelho vibrante',
    colors: {
      primary: '#F44336',
      secondary: '#C62828',
      background: {
        default: '#1A0A0A',
        paper: '#2D1B1B',
      },
      text: {
        primary: '#ffffff',
        secondary: '#EF5350',
      },
      border: {
        primary: 'rgba(244, 67, 54, 0.2)',
        hover: 'rgba(244, 67, 54, 0.5)',
        focus: '#F44336',
      },
      hover: {
        light: 'rgba(244, 67, 54, 0.1)',
        medium: 'rgba(244, 67, 54, 0.2)',
      },
      progress: {
        background: 'rgba(255, 255, 255, 0.1)',
        fill: '#F44336',
      },
      gradient: {
        top: '#F44336',
        bottom: '#C62828',
      },
    },
  },
};

// Get theme by key
export const getTheme = (themeKey) => {
  return themes[themeKey] || themes.douradoo;
};

// Get all theme keys
export const getThemeKeys = () => {
  return Object.keys(themes);
};

// Default theme key
export const DEFAULT_THEME_KEY = 'roxo'; // Minimalista

